<template>
  <v-container fluid>
    <v-btn
      v-if="false"
      color="primary"
      fab
      fixed
      bottom
      right
      @click="$router.push('/distributor/products/add')"
    >
      <v-icon icon="add" />
    </v-btn>
    <v-row>
      <v-col cols="9">
        <product-list-table
          :filters="filters"
          ref="productListTable"
          @click="openProductView"
        />
      </v-col>
      <v-col cols="3">
        <v-card>
          <v-card-title>
            <div>
              <h3 class="text-h5 mb-2">Filters</h3>
            </div>
          </v-card-title>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="filters.name"
                label="Name"
                v-on:keyup="$refs.productListTable.applyFilter()"
              />
              <v-text-field
                v-model="filters.type"
                label="Type"
                v-on:keyup="$refs.productListTable.applyFilter()"
              />
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ProductListTable from "./ProductListTable";

export default {
  components: {
    "product-list-table": ProductListTable,
  },

  data() {
    return {
      filters: { name: "", type: "" },
    };
  },

  mounted() {
    this.$store.state.title = "Product List";
    this.$store.state.topTitle = false;
  },

  methods: {
    openProductView(product) {
      this.$router.push(`/distributor/products/${product.id}`);
    },
  },
};
</script>
